export default __webpack_public_path__ + "static/media/coinbase-logo.9a953ad0.svg";